<h2>Invoices</h2>
<div class="invoices-menu">
  <a *ngFor="let invoice of invoices" routerLink="/detail/{{ invoice.id }}">
    {{ invoice.name }}
  </a>
</div>
